import 'es6-promise/auto'

import Vue from 'vue'
import Vuex from 'vuex'
import App from './pages/App'
import router from './router/router'
import {store} from './store/store'

// bootstrap
// import {Dropdown, Modal} from 'bootstrap-vue/es/components'
// import { VBTooltip } from 'bootstrap-vue/es/directives'

import {DropdownPlugin, CarouselPlugin, ModalPlugin, EmbedPlugin, VBTooltip, ButtonPlugin,ButtonGroupPlugin} from 'bootstrap-vue'

Vue.directive('b-tooltip', VBTooltip)
Vue.use(DropdownPlugin);
Vue.use(CarouselPlugin);
Vue.use(ModalPlugin);
Vue.use(EmbedPlugin);
Vue.use(ButtonPlugin);
Vue.use(ButtonGroupPlugin);

// Font awesome
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {library} from '@fortawesome/fontawesome-svg-core'
import {faTimesCircle, faAngleLeft, faAngleRight, faPlus, faTimes, faMinus, faCheck, faExclamation, faEye} from '@fortawesome/free-solid-svg-icons'
import {faCheckCircle, faCalendarAlt, faPencilAlt, faArrowRight, faArrowLeft, faFileSignature, faEyeSlash} from '@fortawesome/free-solid-svg-icons'
import {faTrashAlt, faLock, faUser, faSpinner, faCloudDownloadAlt, faCloudUploadAlt,faFileDownload} from '@fortawesome/free-solid-svg-icons'
import {faCopy, faHashtag, faPaperPlane, faAngleUp, faFile, faAngleDown, faFlag, faEnvelope, faPrint, faDatabase, faBan} from '@fortawesome/free-solid-svg-icons'

Vue.component('font-awesome-icon', FontAwesomeIcon);
library.add(faTimesCircle, faAngleLeft, faAngleRight, faTrashAlt, faPlus, faTimes, faMinus, faCheck, faExclamation);
library.add(faCheckCircle, faCalendarAlt, faLock, faUser, faSpinner, faEye, faPencilAlt, faCloudDownloadAlt,faFileDownload);
library.add(faArrowRight, faArrowLeft, faCloudUploadAlt, faCopy, faHashtag, faCloudDownloadAlt, faPaperPlane,faEyeSlash);
library.add(faAngleDown, faAngleUp, faFlag, faEnvelope, faFile, faPrint, faDatabase, faFileSignature,faBan);

// Translator
import { apiLink } from './store/api';
import { TitanTranslator } from './core/Translator/translator.js'
import { prettyBytes } from './core/Libs/utils'

const translator = new TitanTranslator(apiLink(), process.env.translator);
export const i18n = translator.i18n;

// Extended form builder
import birthNumber from './components/form/birthNumber';

Vue.component("field-titanBirthNumber", birthNumber);

// Others
Vue.config.productionTip = false;
Vue.use(Vuex);

/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  router,
  i18n: translator.i18n,
  store,
  components: {App},
  template: '<App/>'
});

//window.app = app;

Vue.mixin({
  methods: {
    hasPermission(slug, type) {
      return this.$store.getters['account/hasPermission'](slug, type);
    },
    getUserStore() {
      return this.$store.getters['account/userStore'];
    },
    getAccount() {
        return this.$store.state.account.user;
    },
    isNotIntKar() {
        return this.$store.state.account.user.panel.id !== 1;
    }
  }
});

// Turn off loading of languages
translator.loadMessages(translator.i18n.locale).then(res => {
  app.$store.state.translate.loading = false;
});



Vue.filter('prettyBytes', function (num) {
  return prettyBytes(num);
});



// WEBPACK FOOTER //
// ./src/main.js